import type { Ref } from "react";
import { useTranslation } from "react-i18next";

import { LOGIC, type Logic } from "../constants";
import { getLogicLabel } from "../labels";

import { SegmentedControl, type SegmentedControlProps } from "@/components/ui/v2/segmented-control";

type LogicToggleProps = {
  value?: Logic;
  onChange: (value: Logic) => void;
  label: string;
  readOnly?: boolean;
  rootRef?: Ref<HTMLDivElement>;
} & Pick<SegmentedControlProps<Logic>, "aria-invalid" | "aria-describedby">;

export function LogicToggle({
  value,
  onChange,
  label,
  readOnly = false,
  rootRef,
  ...ariaProps
}: LogicToggleProps) {
  const { t } = useTranslation();

  const options = [
    { value: LOGIC.AND, label: getLogicLabel(t, LOGIC.AND) },
    { value: LOGIC.OR, label: getLogicLabel(t, LOGIC.OR) },
  ];

  return (
    <SegmentedControl
      value={value}
      onValueChange={onChange}
      options={options}
      label={label}
      disabled={readOnly}
      rootRef={rootRef}
      className="font-mono"
      {...ariaProps}
    />
  );
}
